import React, { PureComponent } from 'react';
import AsyncSelect from 'react-select/async';

import TravelerHelper from '../../../Helper/Traveler';
import APIHelper from '../../../Helper/APIHelper';
import APIGet from '../../../API/APIGet';
import { toast } from 'react-toastify';

export default class TravelerDetail extends PureComponent {
	getDefaultTravelerOptions = () => {
		const { initTravelers } = this.props;
		return (initTravelers || []).map(t => ({
			value: t.id,
			label: TravelerHelper.getNameAndContact(t),
			travelerRecord: t,
		}));
	};

	loadTravelerOptions = async inputValue => {
		const q = (inputValue || '').trim();
		if (!q) return this.getDefaultTravelerOptions();

		const request = await APIGet('travelers?page=1&perPage=40&filter=' + q);
		if (!APIHelper.handleAPIResponse(this, request)) {
			toast.error('ไม่สามารถดึงข้อมูล Traveler ได้ กรุณาลองใหม่อีกครั้ง');
			return [];
		}

		const responseData = request.data;
		const apiTravelers = Array.isArray(responseData) ? responseData : responseData.data || [];
		return apiTravelers.map(t => ({
			value: t.id,
			label: TravelerHelper.getNameAndContact(t),
		}));
	};

	render() {
		const { selectedTraveler } = this.props;
		const getTravelerLabel = option => {
			if (!option) return '';
			return option.label;
		};

		const travelerSelect = () => {
			// console.log('selectedTraveler: ', selectedTraveler);
			return (
				<AsyncSelect
					name="traveler"
					// value={this.state.selectedTraveler}
					value={selectedTraveler ? { value: selectedTraveler.value, label: selectedTraveler.label } : null}
					clearable={false}
					onChange={value => {
						this.props.onTravelerChange(value);
						// this.setState({ selectedTraveler: value });
					}}
					defaultOptions={this.getDefaultTravelerOptions()}
					cacheOptions
					loadOptions={this.loadTravelerOptions}
					getOptionValue={option => option && (option.value != null ? option.value : option.id)}
					getOptionLabel={getTravelerLabel}
					loadingMessage={() => 'กำลังค้นหา...'}
					placeholder="ค้นหาจากชื่อ, เบอร์โทร, email"
					noOptionsMessage={() => 'ไม่มีข้อมูล Travel'}
				/>
			);
		};

		if (!selectedTraveler) {
			return (
				<div className="columns">
					<div className="column is-12">
						<label className="label">ลูกค้า</label>
						{travelerSelect()}
					</div>
				</div>
			);
		}

		return (
			<div>
				<div className="columns">
					<div className="column is-12">
						<label className="label">ลูกค้า</label>
						{travelerSelect()}
					</div>
				</div>
				<div className="columns">
					<div className="column is-6">
						<label className="label">เบอร์โทร</label>
						<label className="label">{selectedTraveler && selectedTraveler.telephone ? selectedTraveler.telephone : '-'}</label>
					</div>
					<div className="column is-6">
						<label className="label">Email</label>
						<label className="label">{selectedTraveler && selectedTraveler.email ? selectedTraveler.email : '-'}</label>
					</div>
				</div>
			</div>
		);
	}
}
